interface Props {
  to: string
}

const SquarespaceLink: React.FunctionComponent<Props> = ({ to, children }) => {
  return (
    <a
      href={to}
      className="underline hover:text-denim text-yellow transition-colors"
    >
      {children}
    </a>
  )
}

export default SquarespaceLink
